import CircularLoading from "components/CircularLoading";
import { useTrialResultQuery } from "@generated/graphql";
import { Stack } from "@mui/material";
import { useParams } from "react-router-dom";
import RepositoryCheck from "./components/blocks/RepositoryCheck/RepositoryCheck";
import CodeReviewCommon from "./components/blocks/CodeReviewCommon";
import CommonInfo from "./components/blocks/CommonInfo";
import RecommendationBlock from "./components/blocks/RecomendationBlock";
import AnswerStatistics from "./components/blocks/AnswerStatistics";
import CandidateAnswers from "./components/blocks/CandidateAnswers";

const ResultTab = () => {
  const { id } = useParams();
  const { data, loading } = useTrialResultQuery({
    variables: {
      trialId: id!,
    },
  });
  const knowledgeBlocks = data?.trial?.examination.competencyMap.competences;
  const trial = data?.trial;

  const isRepositoryCheckExist = !!trial?.trialRepositoryChecks?.length;
  const lastRepositoryCheck = trial?.trialRepositoryChecks?.[0];

  if (loading) return <CircularLoading />;

  return (
    <Stack
      py={2.5}
      spacing={2.5}>
      {/* eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain */}
      <CommonInfo score={trial?.candidateScore!} />
      {isRepositoryCheckExist && lastRepositoryCheck && <CodeReviewCommon trialRepositoryCheck={lastRepositoryCheck} />}
      <RecommendationBlock knowledgeBlocks={knowledgeBlocks} />
      <AnswerStatistics knowledgeBlocks={knowledgeBlocks} />
      {trial && <CandidateAnswers trial={trial} />}
      {isRepositoryCheckExist && lastRepositoryCheck && <RepositoryCheck trialRepositoryCheck={lastRepositoryCheck} />}
    </Stack>
  );
};

export default ResultTab;
